"use client";
import ContentItem from './ContentItem';
import styles from './styles.module.scss';
import ClientImage from "./ClientImage";

const ContentBlock = props => {
    const {imageOnRight, headline, image, contentItems, imageFill = true} = props || {};

    const renderHeadline = () => {
      if(!headline) return false;
      return(
        <h2 className={styles.contentBlock__headline}>
          {headline}
        </h2>
      );
    }

    const renderImage = () => {
      return (
        <ClientImage
          image={image}
          imageFill={imageFill}
        />
      );
    }
    const renderContentItems = () => {
      return  contentItems && contentItems?.map((item, index)=> {
        return(
          <div key={index} className={`${imageOnRight ? styles.contentBlock__contentWrapRight : styles.contentBlock__contentWrapLeft}`}>
            <ContentItem {...item} />
          </div>

        );
      })
    }
  
    return (
        <section className={styles.contentBlock}>
          <div className="container">
            {renderHeadline()}
            <div className={`${styles.contentBlock__inner} ${imageOnRight ? styles.contentBlock__imageOnRight : ``}`}>
              <div className={styles.contentBlock__col}>
                <div className={styles.contentBlock__image}>
                  {renderImage()}
                </div>
              </div>
              <div className={styles.contentBlock__col}>
                {renderContentItems()}
              </div>
            </div>
          </div>
        </section>
    );
}

export default ContentBlock;